// src/components/MathModeMenu.js
import React from 'react';

const gameTitles = {
    'tarik-tambang': 'Tarik Tambang Matematika',
    'panjat-pinang': 'Panjat Pinang Matematika',
    'balap-karung': 'Balap Karung Matematika',
};

function MathModeMenu({ gameType, onSelectMode, onBack }) {
    const title = gameTitles[gameType] || 'Pilih Mode';

    return (
        <div className="menu-screen" style={{ display: 'flex' }}>
            <div className="menu-container">
                <h1 className="menu-title">{title}</h1>
                <p className="menu-subtitle">Pilih Jenis Operasi</p>
                <div className="menu-buttons">
                    <button className="menu-btn" onClick={() => onSelectMode('addition')}>➕ Penjumlahan</button>
                    <button className="menu-btn" onClick={() => onSelectMode('subtraction')}>➖ Pengurangan</button>
                    <button className="menu-btn" onClick={() => onSelectMode('multiplication')}>✖️ Perkalian</button>
                    <button className="menu-btn" onClick={() => onSelectMode('division')}>➗ Pembagian</button>
                </div>
                <button className="back-btn" onClick={onBack}>← Kembali</button>
            </div>
        </div>
    );
}

export default MathModeMenu;